import classNames from 'classnames';

import lang from '../../lib/language';

import IconClose from '../../assets/img/icon-close-black.svg';
import ClickableImage from '../ClickableImage/ClickableImage';

import styles from './FavouriteSymbolsLimitModal.module.scss';

type Props = {
    closeMessage: () => void
    isMobile?: boolean
    isSymbolDetails?: boolean;
}

const FavouriteSymbolsLimitModal = ({ closeMessage, isMobile, isSymbolDetails }: Props) => (
  <div className={classNames(styles.wrapper,
    { [styles.mobileWrapper]: isMobile },
    { [styles.symbolDetailsMobileWrapper]: isMobile && isSymbolDetails })}
  >
    <div className={styles.text}>{lang.commonWatchlistFavoutesLimitReached()}</div>
    <ClickableImage
      id="max15FavoriteSymbolsLimit"
      alt="X"
      src={IconClose}
      className={classNames(styles.iconClose, { [styles.mobileViewIcon]: isMobile })}
      onClick={closeMessage}
    />
  </div>
);

export default FavouriteSymbolsLimitModal;
